module.exports = __webpack_public_path__ + "static/media/Copy-Icon.aa60676f.svg";